import log from 'loglevel'
import { LocationPlayCompositeLayer } from '@/js/custom-layers/LocationPlayCompositeLayer.js'
import { DataFilterExtension } from '@deck.gl/extensions'

// レイヤーID
const LAYER_ID = 'locationPlay'

/**
 * 位置再生のレンダラー
 */
class LocationPlayRenderer {
  /**
   * レイヤーID
   * @returns {String}
   */
  static LAYER_ID() {
    return LAYER_ID
  }

  /**
   * コンストラクタ
   */
  constructor() {}

  /**
   * レンダラー関数を作成する
   * @param {Object} data 描画するデータ
   * @param {Object} props 追加・上書きprops
   * @returns {Object} レンダラー {id: String, render: Function.<LocationPlayCompoisiteLayer>}
   */
  createRenderer(data, props) {
    log.debug('LocationPlayRenderer create', data, props)
    return {
      id: LAYER_ID,
      render: () =>
        new LocationPlayCompositeLayer({
          id: LAYER_ID,
          data: typeof data === 'function' ? data() : data,
          extensions: [new DataFilterExtension({ filterSize: 1 })],
          parameters: {
            blend: true,
            depthRange: [0, 0.89],
          },
          updateTriggers: {
            getPosition: [props.currentTime],
            getPath: [props.currentTime],
            ...props.updateTriggers,
          },
          _subLayerProps: {
            head: props.head,
            trail: props.trail,
          },
          ...props,
        }),
    }
  }
}

LocationPlayRenderer.LAYER_ID = LAYER_ID

export default LocationPlayRenderer
